import { buildQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import moment from "moment";
import { request } from "services/request";

const resource = "api/logs";
const listQuery = { orderBy: ["requestUrlPath", "userName", "date desc"] };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(`${resource}/getApiRequests${query}`, { method: "GET" }, { countInHeaders: true });
};

const getItem = ({ id, date }: { id: number; date: string }) => {
    const query = buildQuery({
        filter: { traceId: id, ...(date ? { date: { ge: moment(date).subtract(1, "m").toDate() } } : {}) },
    });
    return request(`${resource}/getApiRequests${query}`, { method: "GET" }).then((data) => data && data[0]);
};

export { index, getItem };
